'use client'

import { Button, Icon } from '@graftcode/design-system'

import { WIZARD_COPY } from '../../const'
import type { WizardActionsProps } from '../../types'

import styles from './WizardActions.module.scss'

export function WizardActions({ onDismiss }: WizardActionsProps) {
  return (
    <div className={styles.actions}>
      <Button text={WIZARD_COPY.actions.close} variant="outlined" onClick={onDismiss} />
      <Button text={WIZARD_COPY.actions.done} icon={Icon.CheckmarkRegular} onClick={onDismiss} />
    </div>
  )
}
